import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import MainNavbar from "./components/navbar";
import ScrollToTop from "./components/ScrollToTop";
import SiteModeProvider from "./components/SiteModeProvider";
import CookieConsentProvider from "./components/CookieConsent/CookieConsentContext";
import { RETAIL_ROUTES, LEGACY_REDIRECTS } from "./lib/siteMode";
import Footer from "./components/footer";
import Container from "react-bootstrap/Container";

// Each landing page is its own route and is only ever needed once a visitor
// actually navigates to it, so they're code-split into separate chunks
// instead of all shipping in the main bundle on every page load.
const DualEducation = lazy(() => import("./landings/corporate/DualEducation"));
const NemzetiBajnokok = lazy(() =>
  import("./landings/corporate/NemzetiBajnokok")
);
const ElmaradottTersegBruhazas = lazy(() =>
  import("./landings/corporate/ElmaradottTersegBruhazas")
);
const BusinessLoanConsulting = lazy(() =>
  import("./landings/corporate/BusinessLoanConsulting")
);
const CorporateAccountOptimize = lazy(() =>
  import("./landings/corporate/CorporateAccountOptimize")
);
const PrivacyPolicy = lazy(() => import("./landings/PrivacyPolicy"));
const Impresszum = lazy(() => import("./landings/Impresszum"));
const Rolunk = lazy(() => import("./landings/Rolunk"));
const ThanksPage = lazy(() => import("./landings/ThanksPage"));
const ThanksPageRetail = lazy(() =>
  import("./landings/retail/ThanksPageRetail")
);
const FrameworkContract = lazy(() =>
  import("./landings/corporate/FrameworkContract")
);
const VallalatiHome = lazy(() => import("./landings/VallalatiHome"));
const LakossagiHome = lazy(() => import("./landings/LakossagiHome"));
const Jelzaloghitel = lazy(() => import("./landings/retail/Jelzaloghitel"));
const SzemelyiKolcson = lazy(() =>
  import("./landings/retail/SzemelyiKolcson")
);
const LakossagiBankszamla = lazy(() =>
  import("./landings/retail/LakossagiBankszamla")
);
const Nyugdijmegtakaritas = lazy(() =>
  import("./landings/retail/Nyugdijmegtakaritas")
);
const Eletbiztositas = lazy(() => import("./landings/retail/Eletbiztositas"));

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <SiteModeProvider>
        <CookieConsentProvider>
          <MainNavbar />
          <main>
            <Suspense fallback={null}>
              <Routes>
                {/* Retail (lakossági) — default page at "/" */}
                <Route path="/" element={<LakossagiHome />} />
                <Route path="/lakossagi" element={<LakossagiHome />} />

                {/* Corporate (vállalati) */}
                <Route path="/vallalati" element={<VallalatiHome />} />
                <Route
                  path="/nemzeti-bajnokok"
                  element={<NemzetiBajnokok />}
                />
                <Route path="/dualis-kepzes" element={<DualEducation />} />
                <Route
                  path="/elmaradott-tersegek-tamogatasa"
                  element={<ElmaradottTersegBruhazas />}
                />
                <Route
                  path="/vallalati-hitel"
                  element={<BusinessLoanConsulting />}
                />
                <Route
                  path="/szamlaoptimalizalas"
                  element={<CorporateAccountOptimize />}
                />
                <Route
                  path="/penzugyi-orangyal"
                  element={<FrameworkContract />}
                />

                {/* Retail (lakossági) — nested products */}
                <Route
                  path={RETAIL_ROUTES.jelzaloghitel}
                  element={<Jelzaloghitel />}
                />
                <Route
                  path={RETAIL_ROUTES.szemelyiKolcson}
                  element={<SzemelyiKolcson />}
                />
                <Route
                  path={RETAIL_ROUTES.bankszamla}
                  element={<LakossagiBankszamla />}
                />
                <Route
                  path={RETAIL_ROUTES.nyugdijmegtakaritas}
                  element={<Nyugdijmegtakaritas />}
                />
                <Route
                  path={RETAIL_ROUTES.eletbiztositas}
                  element={<Eletbiztositas />}
                />

                {/* Legacy flat retail paths → nested equivalents */}
                {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
                  <Route
                    key={from}
                    path={from}
                    element={<Navigate to={to} replace />}
                  />
                ))}

                {/* Shared */}
                <Route
                  path="/adatkezelesi-tajekoztato"
                  element={<PrivacyPolicy />}
                />
                <Route path="/impresszum" element={<Impresszum />} />
                <Route path="/rolunk" element={<Rolunk />} />
                <Route path="/koszonjuk" element={<ThanksPage />} />
                <Route
                  path="/koszonjuk-lakossagi"
                  element={<ThanksPageRetail />}
                />
              </Routes>
            </Suspense>
          </main>
          <Container className="py-0">
            <Footer />
          </Container>
        </CookieConsentProvider>
      </SiteModeProvider>
    </BrowserRouter>
  );
}
